import globalAxios from 'axios';
import { createRequestFunction, assertParamExists, DUMMY_BASE_URL, setSearchParams, serializeDataIfNeeded, setApiKeyToObject, toPathString } from '../common.mjs';
import { BASE_PATH, BaseAPI } from '../base.mjs';
import { makeRemoteWithOpenapiGenerator } from '@flex-packages/remote-core';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const SiteAccessLogPublicControllerApiAxiosParamCreator = function(configuration) {
  return {
    /**
     * 사이트 접근 로그 저장
     * @param {SiteAccessLogPublicControllerApiCreateSiteAccessLogRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createSiteAccessLog: ({ siteAccessLogCreateRequest, userAgent }, options = {}) => {
      assertParamExists("createSiteAccessLog", "siteAccessLogCreateRequest", siteAccessLogCreateRequest);
      const localVarPath = "/api-public/v2/recruiting/sites/access";
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "POST" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      setApiKeyToObject(localVarHeaderParameter, "x-flex-aid", configuration);
      setApiKeyToObject(localVarHeaderParameter, "WS_AID", configuration);
      if (userAgent !== void 0 && userAgent !== null) {
        localVarHeaderParameter["user-agent"] = String(userAgent);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      localVarRequestOptions.data = serializeDataIfNeeded(siteAccessLogCreateRequest, localVarRequestOptions, configuration);
      return __spreadProps(__spreadValues({}, localVarRequestOptions), {
        identifier: "createSiteAccessLog",
        url: toPathString(localVarUrlObj)
      });
    }
  };
};
const SiteAccessLogPublicControllerApiFp = function(configuration) {
  const localVarAxiosParamCreator = SiteAccessLogPublicControllerApiAxiosParamCreator(configuration);
  return {
    /**
     * 사이트 접근 로그 저장
     * @param {SiteAccessLogPublicControllerApiCreateSiteAccessLogRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createSiteAccessLog(requestParameters, options) {
      const localVarAxiosArgs = localVarAxiosParamCreator.createSiteAccessLog(requestParameters, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH);
    }
  };
};
const SiteAccessLogPublicControllerApiFactory = function(configuration, basePath, axios) {
  const localVarFp = SiteAccessLogPublicControllerApiFp(configuration);
  return {
    /**
     * 사이트 접근 로그 저장
     * @param {SiteAccessLogPublicControllerApiCreateSiteAccessLogRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createSiteAccessLog(requestParameters, options) {
      return localVarFp.createSiteAccessLog(requestParameters, options)(axios, basePath);
    }
  };
};
class SiteAccessLogPublicControllerApi extends BaseAPI {
  /**
   * 사이트 접근 로그 저장
   * @param {SiteAccessLogPublicControllerApiCreateSiteAccessLogRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SiteAccessLogPublicControllerApi
   */
  createSiteAccessLog(requestParameters, options) {
    return SiteAccessLogPublicControllerApiFp(this.configuration).createSiteAccessLog(requestParameters, options)(this.axios, this.basePath);
  }
}
const createSiteAccessLogRemote = makeRemoteWithOpenapiGenerator({
  requestArgsCreator: SiteAccessLogPublicControllerApiAxiosParamCreator().createSiteAccessLog,
  requestFn: SiteAccessLogPublicControllerApiFp().createSiteAccessLog
});

export { SiteAccessLogPublicControllerApi, SiteAccessLogPublicControllerApiAxiosParamCreator, SiteAccessLogPublicControllerApiFactory, SiteAccessLogPublicControllerApiFp, createSiteAccessLogRemote };
//# sourceMappingURL=site-access-log-public-controller-api.mjs.map
